import React from 'react';

export const DisabilityPeriodInfo = () => (
  <>
    <p>De eigen risico periode is het aantal dagen waarover u geen uitkering ontvangt. Hoe langer deze termijn, hoe lager de premie. </p>
  </>
);
